if (!customElements.get("gift-card-recipient-form")) {
  customElements.define(
    "gift-card-recipient-form",
    class GiftCardRecipientForm extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.selectors = {
          checkBox: `[data-recipient-checkbox="${this.sectionId}"]`,
          controlInput: `[data-recipient-control="${this.sectionId}"]`,
          emailInput: `[data-recipient-email="${this.sectionId}"]`,
          nameInput: `[data-recipient-name="${this.sectionId}"]`,
          messageInput: `[data-recipient-message="${this.sectionId}"]`,
          sendOnInput: `[data-recipient-send-on="${this.sectionId}"]`,
          offSetInput: `[data-recipient-off-set="${this.sectionId}"]`,
        };

        this.currentProductVariantId = this.dataset.productVariantId;
        this.checkboxInput = this.querySelector(this.selectors.checkBox);
        this.hiddenControlField = this.querySelector(
          this.selectors.controlInput,
        );
        this.activeInputs = {
          email: this.querySelector(this.selectors.emailInput),
          name: this.querySelector(this.selectors.nameInput),
          message: this.querySelector(this.selectors.messageInput),
          send_on: this.querySelector(this.selectors.sendOnInput),
        };

        this.offsetProperty = this.querySelector(this.selectors.offSetInput);

        this.checkboxInput.disabled = false;
        this.hiddenControlField.disabled = true;

        if (this.offsetProperty)
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.onChange();
        this.addEventListener("change", this.onChange.bind(this));
      }

      connectedCallback() {
        document.addEventListener("cart:errors", ({ detail }) => {
          if (
            detail.source === "product-form" &&
            detail.productVariantId.toString() === this.currentProductVariantId
          ) {
            this.displayErrorMessage(detail.errors);
          }
        });

        document.addEventListener("variant:changed", ({ detail }) => {
          const wrappingProductForm = this.closest("product-form");
          const variantSelectors = wrappingProductForm.querySelector(
            "product-form-selectors",
          );

          if (variantSelectors === detail.source) {
            this.currentProductVariantId = detail.variant.id.toString();
          }
        });

        document.addEventListener("mini-cart:open", () => {
          this.resetRecipientForm();
        });
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessages();
        }
      }

      inputFields() {
        return Object.keys(this.activeInputs).map(
          (key) => this.activeInputs[key],
        );
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ""));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(body) {
        if (typeof body === "object") {
          return Object.entries(body).forEach(([key, value]) => {
            const inputEl = this.activeInputs[key];
            const ErrorEl = inputEl.parentNode.querySelector(
              ".input-label__error",
            );
            const message = `${value.join(", ")}`;
            ErrorEl.innerText = `${message}.`;

            inputEl.setAttribute("aria-invalid", true);
            inputEl.classList.add("error");
          });
        }

        this.errorMessage.innerText = body;
      }

      clearErrorMessages() {
        this.inputFields().forEach((field) => {
          field.setAttribute("aria-invalid", false);
          field.classList.remove("error");
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessages();
        }
      }
    },
  );
}
